import React from 'react'
import classNames from 'classnames'

import { SingleAvatar } from 'components/UI/Avatars/Avatars'
import Typography from 'components/UI/Typography/Typography'

import { Rating } from './Rating'

import styles from './ReviewBox.module.css'

export type ReviewBoxProps = {
  authorName?: string
  message: string
  rating: number
  date: string
  className?: string
}

export const ReviewBox: React.FC<ReviewBoxProps> = ({
  authorName,
  message,
  rating,
  date,
  className,
}) => {
  return (
    <div
      data-cy="reviewBox"
      className={classNames(className, styles.reviewBox)}
    >
      <div className={styles.header}>
        {authorName && (
          <SingleAvatar
            className={styles.avatar}
            size="large"
            name={authorName}
          />
        )}
        <div className={styles.nameAndDate}>
          {authorName && (
            <Typography.BodySmallBold>
              <span className={styles.name}>{authorName}</span>
            </Typography.BodySmallBold>
          )}
          <Typography.BodySmall>
            <span className={styles.date}>{date}</span>
          </Typography.BodySmall>
        </div>
      </div>
      <Rating value={rating} />
      <div className={styles.message}>
        <Typography.BodySmall>
          <span>{message}</span>
        </Typography.BodySmall>
      </div>
    </div>
  )
}

export default ReviewBox
